import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { DebitsActions } from './debits.actions';

@Injectable({
  providedIn: 'root'
})
export class DebitsEffects {
  sendDebitsEffect$: Observable<Action> = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(DebitsActions.submitSuccess),
        tap(() => {})
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions) {}
}
